"use strict";

exports.__esModule = true;
exports.getValueFormatter = exports.getQuarterTick = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _d3Format = require("d3-format");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _constants = require("../../constants");
var _Utils = require("../../../Utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getValueFormatter = exports.getValueFormatter = function getValueFormatter(type, timezoneName) {
  return function (value) {
    switch (type) {
      case _timeAggregationBinMapping.HOUR_PER_DAY:
        if (_momentTimezone["default"].utc(value).tz(timezoneName).get("hour") === 0) {
          return _momentTimezone["default"].utc(value).tz(timezoneName).format("DD MMM");
        }
        return _momentTimezone["default"].utc(value).tz(timezoneName).format("HH:00");
      case _timeAggregationBinMapping.HOUR_OF_DAY:
        return value + ":00";
      case "day":
        return _momentTimezone["default"].utc(value).format("DD MMM");
      case "workday":
        return _momentTimezone["default"].utc(value).format("DD MMM");
      case "week":
        return _momentTimezone["default"].utc(value).format("DD MMM");
      case "month":
        return _momentTimezone["default"].utc(value).format("MMM'YY");
      case "quarter":
        return getQuarterTick(value);
      case "year":
        return _momentTimezone["default"].utc(value).format("YYYY");
      case _constants.METRICS_MILLISECOND:
        return value === 0 ? 0 : (0, _Utils.formatDuration)(value).replace(" ", "");
      case _constants.METRICS_FRACTIONAL_PERCENT:
        return value === 0 ? 0 : parseFloat(value) * 100 + "%";
      case _constants.METRICS_COUNT:
        return getNumberFormatter(value);
      default:
        return value;
    }
  };
};
var getQuarterTick = exports.getQuarterTick = function getQuarterTick(timestamp) {
  var quarterMonth = _momentTimezone["default"].utc(timestamp).format("MMM");
  if (quarterMonth === "Jan") {
    return "Q1-Jan'" + _momentTimezone["default"].utc(timestamp).format("YY");
  } else if (quarterMonth === "Apr") {
    return "Q2-Apr'" + _momentTimezone["default"].utc(timestamp).format("YY");
  } else if (quarterMonth === "Jul") {
    return "Q3-Jul'" + _momentTimezone["default"].utc(timestamp).format("YY");
  } else if (quarterMonth === "Oct") {
    return "Q4-Oct'" + _momentTimezone["default"].utc(timestamp).format("YY");
  } else {
    return quarterMonth;
  }
};
var getNumberFormatter = function getNumberFormatter(value) {
  var parsedValue = parseFloat(value);
  var SI = (0, _d3Format.format)(".2s");
  return parsedValue >= 100000 ? parsedValue % 1 === 0 ? SI(parsedValue).replace(".0", "") : SI(parsedValue) : parsedValue;
};